/* eslint-disable @typescript-eslint/explicit-module-boundary-types */
/* eslint-disable @typescript-eslint/no-explicit-any */
// @ts-nocheck
import { send, track } from '@kd/loggerh5';
import { urlExt } from 'kdlib/url';
import { VisibilityObserver } from 'kdlib/visibility-observer';
import { VNode } from 'vue';

function paramsParser(params: string) {
  if (params.match(/&/) !== null) {
    params = urlExt.queryToJson(params);
    console.log('🚀 ~ file: logger.ts ~ line 12 ~ paramsParser ~ params', params);
  } else {
    params = { name: params };
  }
  return params;
}

function loggerPVHandler(value: any) {
  const loggerContent = paramsParser(value);
  const { name = '' } = loggerContent;
  send(name, {
    type: 'pv',
    ...loggerContent
  });
  track(name, {
    ...loggerContent
  });
}

function loggerClickHandler(
  target: { offsetX: any; offsetY: any },
  el: { dataset: { loggerClickHits: any } },
  value: any
) {
  const loggerClickHits = 'loggerClickHits' in el ? el.dataset.loggerClickHits : 1;
  el.dataset.loggerClickHits = loggerClickHits;
  const loggerContent = paramsParser(value);
  send(value, {
    type: 'click',
    offsetX: target.offsetX,
    offsetY: target.offsetY,
    name: value,
    hits: loggerClickHits,
    ...loggerContent
  });
  track(value, {
    ...loggerContent
  });
}

const dirLogger = {
  loggerPV: {
    bind: (el: HTMLElement, { value, arg }: any, vnode: VNode): void => {
      if (!value) {
        return;
      }
      if (typeof IntersectionObserver === 'undefined') {
        console.warn('[loggerPV] IntersectionObserver API is not available in your browser.'); // eslint-disable-line
      } else {
        el._kd_logger = new VisibilityObserver(el, arg || '', vnode, visible => {
          // eslint-disable-line
          visible && loggerPVHandler(value);
        });
      }
    },
    unbind: (el: { _kd_logger: any }): void => {
      const observer = el._kd_logger;
      if (observer) {
        observer.destroy();
        delete el._kd_logger;
      }
    },
    update: (el: { _kd_logger: any }, { value, oldValue, arg }: any, vnode: any): void => {
      if (value === oldValue) {
        return;
      }
      const observer = el._kd_logger;
      if (!value) {
        this.unbind(el);
        return;
      }
      if (observer) {
        observer.create(el, vnode, () => {
          loggerPVHandler(value);
        });
      } else {
        this.bind(el, { value, arg }, vnode);
      }
    }
  },
  loggerClick: {
    bind: (
      el: { addEventListener: (arg0: string, arg1: (target: any) => void, arg2: boolean) => void },
      { value }: any,
      vnode: { context: { $nextTick: (arg0: () => void) => void } }
    ): void => {
      vnode.context.$nextTick(() => {
        el.addEventListener(
          'click',
          (target: any) => {
            loggerClickHandler(target, el, value);
          },
          false
        );
      });
    },
    unbind: (
      el: {
        dataset: { loggerClickHits: any };
        removeEventListener: (arg0: string, arg1: (target: any) => void, arg2: boolean) => void;
      },
      { value }: any
    ): void => {
      const loggerClickHits = el.dataset.loggerClickHits;
      if (loggerClickHits) {
        el.removeEventListener(
          'click',
          (target: any) => {
            loggerClickHandler(target, el, value);
          },
          false
        );
      }
    },
    update: (el: { dataset: { loggerClickHits: any } }, { value, oldValue }: any, vnode: any): void => {
      if (value === oldValue) {
        return;
      }
      const loggerClickHits = el.dataset.loggerClickHits;
      if (!value) {
        this.unbind(el, { value });
        return;
      }
      if (!loggerClickHits) {
        this.bind(el, { value }, vnode);
      }
    }
  }
};

export default dirLogger;
